import { api } from '../utils/api';

export type Kinship = {
    id: number;
    name: string;
}

export const getKinshipTypes = () => {
  const url = `/api/v1/users/guest/relation_degrees/?format=json`;

  const res = api.get<Kinship[]>(url);
  return res;
};
